import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';

import { cn } from '@/lib/utils';

const badgeVariants = cva(
  'inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors',
  {
    variants: {
      variant: {
        default: 'border-transparent bg-primary/15 text-primary',
        secondary: 'border-transparent bg-secondary/15 text-secondary',
        positive: 'border-transparent bg-positive/15 text-positive',
        negative: 'border-transparent bg-negative/15 text-negative',
        outline: 'border-border text-foreground',
        // Glow badges — tinted fill + colored text + an accent halo (box-shadow).
        'glow-green':
          'border-positive/40 bg-positive/15 text-[color:var(--nq-up-bright)] shadow-[0_0_12px_rgba(46,230,107,0.35)]',
        'glow-blue':
          'border-primary/45 bg-primary/15 text-[color:var(--nq-blue-bright)] shadow-[0_0_12px_rgba(37,180,224,0.35)]',
        'glow-orange':
          'border-[color:var(--nq-orange-border)] bg-[color:var(--nq-orange-soft)] text-[color:var(--nq-orange-bright)] shadow-[0_0_12px_rgba(249,115,22,0.35)]',
        'glow-gold':
          'border-secondary/45 bg-secondary/15 text-[color:var(--nq-gold-amber)] shadow-[0_0_12px_rgba(247,148,29,0.35)]',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  );
}

export { Badge, badgeVariants };
